import { isEmpty } from 'lodash';
import APP from 'app';
const { Utils } = APP, { translateText, checkPersonalPanNumber, checkCorporatePanNumber, checkAgentUsingCorporatePan, isRoleCorporateEmp } = Utils;

const MESSAGES = {
    str_empty: translateText('str_empty', 'validations'),
    firstName_empty: translateText('firstName_empty', 'validations'),
    lastName_empty: translateText('lastName_empty', 'validations'),
    firstName_specialCharacter: translateText('firstName_specialCharacter', 'validations'),
    firstName_space: translateText('firstName_space', 'validations'),
    firstName_number: translateText('firstName_number', 'validations'),
    lastName_specialCharacter: translateText('lastName_specialCharacter', 'validations'),
    lastName_number: translateText('lastName_number', 'validations'),
    lastName_maxLengthExceed: translateText('lastName_maxLengthExceed', 'validations'),
    email_patternFail: translateText('email_patternFail', 'validations'),
    mobile_length: translateText('mobile_length', 'validations'),
    gstNumber_lengthNotMatch: translateText('gstNumber_lengthNotMatch', 'validations'),
    password_empty: translateText('password_empty', 'validations'),
    password_minimumLength: translateText('password_minimumLength', 'validations'),
    EmailorMobile_validity: translateText('EmailorMobile_validity', 'validations'),
    dob_empty: translateText('dob_empty', 'validations'),
    eD_empty: translateText('eD_empty', 'validations'),
    pid_empty: translateText('pid_empty', 'validations'),
    pNum_incorrect: translateText('pNum_incorrect', 'validations'),
    gstNumber_required: translateText('gstNumber_required', 'validations'),
    gstName_required: translateText('gstName_required', 'validations'),
    pan_incorrect: translateText('pan_incorrect', 'validations'),
    pan_empty: translateText('pan_empty', 'validations'),
    pan_personal: translateText('pan_personal', 'validations'),
    pan_corporate: translateText('pan_corporate', 'validations'),
    pax_unique: translateText('pax_unique', 'validations'),
    pNum_empty: translateText('pNum_empty', 'validations'),
    pNumExp_empty: translateText('pNumExp_empty', 'validations'),
    file_empty: translateText('file_empty', 'validations'),
    corporate_agentPan: translateText("corporate_agentPan", 'validations')
},
    CUSTOM_MESSAGES = {
        EMPTY: translateText('EMPTY', 'validations'),
        SPECIAL_CHAR: translateText('SPECIAL_CHAR', 'validations')
    },

    createErrorMessage = (field, context) => {
        return {
            success: false,
            errMsg: MESSAGES[`${field}_${context}`]
        };
    };


export const EmailValidation = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(_[0-9]+)?$/,
        emailValidation = re.test(String(email).toLowerCase());
    if (!emailValidation) {
        return createErrorMessage('email', 'patternFail');
    }
    return true;
};

export const MobileValidation = (mobile) => {
    const re = /^[0-9]{10}(_[0-9]+)?$/,
        regTest = re.test(mobile);
    if (!regTest) {
        return createErrorMessage('mobile', 'length');
    }
    return true;
};

export const EmailOrMobileValidation = (name) => {
    if (EmailValidation(name) != true && MobileValidation(name) != true) {
        return createErrorMessage('EmailorMobile', 'validity');
    }
    return true;
};

export const DobValidation = (dob, type) => {
    return dob == '' ? createErrorMessage(type, 'empty') : true;
};

export const FirstNameValidation = (firstName, checkWithSpace) => {
    const fn = firstName.trim();
    if (fn.length > 0) {
        const regExValidated = containSpecialChar(fn),
            spaceCheckWithSpecialChar = containSpecialCharWithSpace(fn),
            checkForNumber = containsNumberWithSpace(fn);
        if (regExValidated) {
            return createErrorMessage('firstName', 'specialCharacter');
        }
        if (checkWithSpace && spaceCheckWithSpecialChar) {
            return createErrorMessage('firstName', 'space');
        }
        if (!checkForNumber) {
            return createErrorMessage('firstName', 'number');
        }
        return true;
    }
    return createErrorMessage('firstName', 'empty');
};

export const LastNameValidation = (lastName, firstName) => {
    const ln = lastName.trim(),
        fn = firstName.trim();
    if (ln.length > 0) {
        const regExValidated = containSpecialChar(ln),
            checkForNumber = containsNumberWithSpace(ln);
        if (regExValidated) {
            return createErrorMessage('lastName', 'specialCharacter');
        }
        const maxLengthValidation = exceedMaxLength(`${ln}${fn}`, 45);
        if (maxLengthValidation) {
            return createErrorMessage('lastName', 'maxLengthExceed');
        }
        if (!checkForNumber) {
            return createErrorMessage('lastName', 'number');
        }
        return true;
    }
    return createErrorMessage('lastName', 'empty');
};

export const shouldNotBeEmpty = (str) => {
    if (!isEmpty(str)) {
        return true
    }
    return createErrorMessage('str', 'empty');
}

export const PasswordValidation = (password) => {
    const passTrimed = password.trim(),
        passLength = passTrimed.length;
    if (passLength > 0) {
        if (passLength < 6) {
            return createErrorMessage('password', 'minimumLength');
        }
        return true;
    }
    return createErrorMessage('password', 'empty');
};

export const gstNumberValidation = (gstNumber, igm) => {
    const num = gstNumber.trim(),
        lengthValidated = matchExactLength(gstNumber, 15);
    if (igm && !num.length) return createErrorMessage('gstNumber', 'required');
    if (!lengthValidated && gstNumber.length > 0) return createErrorMessage('gstNumber', 'lengthNotMatch');
    return true;
};

export const gstNameValidation = (gstName, igm) => {
    const num = gstName.trim();
    if (igm && !num.length) return createErrorMessage('gstName', 'required');
    return true;
};

export const gstEmailValidation = (gstEmail) => {
    const email = gstEmail.trim();
    if (email.length > 0) {
        return EmailValidation(gstEmail);
    }
    return true;
};

export const exceedMaxLength = (inputString, maxLength) => {
    return inputString.trim().length > maxLength;
};

export const containSpecialChar = (inputString) => {
    let regEx = /[!@#$%^&*()_+\-=\]{};':"\\|,.<>?]/;
    return regEx.test(inputString);
};

export const containSpecialCharWithSpace = (inputString) => {
    let regEx = /[ !@#$%^&*()_+\-=\]{};':"\\|,.<>?]/;
    return regEx.test(inputString);
};

export const containsNumber = (inputString) => {
    const regEx = /^[A-Za-z]+$/;
    return regEx.test(inputString);
};

export const matchExactLength = (inputString, maxLength) => {
    return inputString.trim().length == maxLength;
};

export const containsNumberWithSpace = (inputString) => {
    const regEx = /^[a-zA-Z ]*$/;
    return regEx.test(inputString);
};

export const passportNoValidation = (pNum, required) => {
    if (required && isEmpty(pNum)) {
        return createErrorMessage('pNum', 'empty');
    } else {
        return true;
    }
};

export const passportExpiryEmpty = (peD, passportRequired) => {
    if (passportRequired && isEmpty(peD)) {
        return createErrorMessage('pNumExp', 'empty');
    } else {
        return true;
    }
};

export const panNoValidation = (pan, required, isppr = false, isCorporate = false, samePanPerBooking, samePanPerRoom, roomKey, guestKey, pt, userPanNumber) => {
    const number = pan ? pan.trim() : '';
    if ((isCorporate || samePanPerBooking || (samePanPerRoom[roomKey] && guestKey !== 0)) && !required)
        return true;
    if (pt == 'CHILD') {
        return true;
    }
    if (number) {
        const regEx = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
        if (regEx.test(number)) {
            if (isCorporate) {
                const valid = !isRoleCorporateEmp() && checkAgentUsingCorporatePan(number, userPanNumber)
                if (valid) {
                    return !checkCorporatePanNumber(number) ? createErrorMessage('pan', 'corporate') : true;
                }
                return createErrorMessage('corporate', 'agentPan')

            }
            if (isppr)
                return !checkPersonalPanNumber(number) ? createErrorMessage('pan', 'personal') : true;
        } else {
            return createErrorMessage('pan', 'incorrect');
        }
    } else if (required) {
        return createErrorMessage('pan', 'empty');
    } else {
        return true;
    }
};

export const roomWiseUniquePaxValidation = (travellerArray) => {
    return travellerArray.map((roomData, _roomIndex) => {
        const { travellerInfo = [], id = "" } = roomData;
        const _travellerInfo = travellerInfo.map((travellerData, _travellerIndex) => {
            const { fN = '', lN = '', errors = {} } = travellerData;
            const name = `${fN}${lN}`;
            const { fN: errorfN, lN: errorlN } = errors;
            if (errorfN != true || errorlN != true) {
                return travellerData;
            }
            let invalid = false;
            for (let roomIndex = 0; roomIndex < travellerArray.length; roomIndex++) {
                const { travellerInfo: _travellerData = [] } = travellerArray[roomIndex] || {};
                for (let travellerIndex = 0; travellerIndex < _travellerData.length; travellerIndex++) {
                    const { fN: toFindFN = '', lN: toFindLN = '' } = _travellerData[travellerIndex] || {};
                    const toFindName = `${toFindFN}${toFindLN}`;
                    if (_roomIndex != roomIndex || _travellerIndex != travellerIndex) {
                        if (toFindName == name) {
                            invalid = true;
                            break;
                        }
                    }
                }
                if (invalid) {
                    break;
                }
            }
            return {
                ...travellerData,
                errors: {
                    ...errors,
                    fN: invalid ? createErrorMessage('pax', 'unique') : true,
                    lN: invalid ? createErrorMessage('pax', 'unique') : true
                }
            }
        });
        return {
            travellerInfo: _travellerInfo,
            id
        }
    });
}

const createCustomErrorMsg = (key, msg) => ({
    success: false,
    errMsg: `${key} ${msg}`
})

export const checkEmpty = (key = '', value = '', required = false) => {
    if (!required) return true;
    if (value.length > 0) return true;
    return createCustomErrorMsg(key, CUSTOM_MESSAGES.EMPTY);
}

export const matchWithPassword = (text1, text2) => {
    return text1 === text2 ? true : createErrorMessage('confirm', 'noMatch');
};

export const fileValidation = (ats = [], check) => {
    if (check)
        return !ats.length ? createErrorMessage('file', 'empty') : true;
    return true;
};

const Validation = {
    shouldNotBeEmpty,
    EmailValidation,
    MobileValidation,
    FirstNameValidation,
    LastNameValidation,
    PasswordValidation,
    EmailOrMobileValidation,
    DobValidation,
    passportNoValidation,
    panNoValidation,
    roomWiseUniquePaxValidation,
    checkEmpty,
    matchWithPassword,
    fileValidation
};

export default Validation;
